import {IPresenter} from "@/rawdogjs/src/interfaces/IPresenter";
import {ScheduleDateView} from "./scheduleDateView";
import {ParcelDependencyContainer} from "@/rawdogjs/src/core/ParcelDependencyContainer";
import {Router} from "@/rawdogjs/src/router";
import {UserStore} from "../../../data/stores/UserStore";
import {BookingStore} from "../../../data/stores/BookingStore";
import {LoadingPresenter} from "../../loading/loadingPresenter";
import {RenderComponent} from "@/rawdogjs/src/renderRoute";
import {BookingApi} from "../../../services/api/base/BookingApi";
import {BookingDayView} from "./bookingDayView";
import {UuidHelper} from "../../../shared/IdentityHelper";

export class ScheduleDatePresenter implements IPresenter {

    public _view: ScheduleDateView;
    private dependencyContainer: ParcelDependencyContainer;

    private weekStartDate: Date;
    private today: Date;

    private selectedDate: Date | null;
    private times: any[];
    private selectedTime: any;
    private _router: Router;
    private _userStore: UserStore;
    private _bookingStore: BookingStore;
    private _queryParams: Record<string, string>;
    private _loading: LoadingPresenter;

    constructor(scheduleView: ScheduleDateView, router: Router, dependencyContainer: ParcelDependencyContainer) {
        this._router = router;
        this._view = scheduleView;
        this.dependencyContainer = dependencyContainer;
    }

    async initialize() {
        const renderComponent = new RenderComponent(this._router);
        this._loading = await renderComponent.render<LoadingPresenter>('loading');
        this._view.$element.append(this._loading._view.$element);
        
        this._userStore = this.dependencyContainer.resolve<UserStore>('UserStore');
        this._bookingStore = this.dependencyContainer.resolve<BookingStore>('BookingStore');
        
        this._loading.setBody('Loading...');
        this._loading.show(true);
        await this._bookingStore.pull();
        this._loading.show(false);

        const date = new Date();
        
        this.today = new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate()
        );

        const startDate = new Date(this.today.getTime()); // clone

        this.generateDates(startDate);

        // select date slot if it is in the currently loaded page (as in paging)
        this._view.addOnClickHandler('#previous-week', () => {
            this.previousWeek()
        });

        this._view.addOnClickHandler('#next-week', () => {
            this.nextWeek()
        });

        this._view.scrollToTop();
    }

    private setSelectedDate(date: Date) {
        this.selectedDate = date;
    }

    // private formatDate(date) {
    //     const options = {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'};
    //     return date.toLocaleDateString('en-us', options);
    // }
    //
    // getCombinedDateTime() {
    //     if (!this.selectedDate || !this.selectedTime)
    //         return null;
    //
    //     return new Date(
    //         this.selectedDate.getFullYear(),
    //         this.selectedDate.getMonth(),
    //         this.selectedDate.getDate(),
    //         this.selectedTime.hour,
    //         this.selectedTime.minute,
    //         0
    //     );
    // }

    private async handleDateButton(element) {

        this.setSelectedDate(new Date(element.dataset.date));

        this._view.highlightSelection(this.selectedDate);

        this._loading.setBody('Saving date...');
        this._loading.show(true);

        //const tenantProfileStore = this.dependencyContainer.resolve<TenantProfileStore>('TenantProfileStore');

        const bookingApi = this.dependencyContainer.resolve<BookingApi>('BookingApi');

        const booking = this._bookingStore.getBooking();
        
        await bookingApi.post({
                setBookingDate: {
                    id: booking.id, // if we don't already have an id, create one
                    date: this.selectedDate.toISOString()
                }
            },
            this._userStore.getParentTenant(),
            true,
            false
        );

        // await this._bookingStore.fetch(
        //     bookingApi,
        //     booking.id,
        //     this._userStore.getParentTenant()
        // );

        const url = `/#/drywallio/schedule-time?id=${booking.id}`;
        this._router.navigate(url);
    }

    inject() {
    }

    addDays(date, numberOfDays) {
        let a = new Date(date);
        return new Date(a.setDate(a.getDate() + numberOfDays));
    }

    generateDates(date) {

        this.weekStartDate = date;

        const weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

        const days = [];

        for (let i = 0; i < 8; i++) {
            let dateValue = this.addDays(date, i);
            days.push(
                new BookingDayView(
                    UuidHelper.newId(),
                    dateValue,
                    weekday[dateValue.getDay()],
                    dateValue.toLocaleDateString(),
                    dateValue > new Date()
                )
            );
        }

        this._view.setBookingDates(days);
 
        const booking = this._bookingStore.getBooking();

        this._view.highlightSelection(new Date(booking.bookingDate));

        if (this.today >= this.weekStartDate) {
            this._view.showPreviousWeek(false);
        } else {
            this._view.showPreviousWeek(true);
        }

        this._view.addOnClickHandler('button[data-date]',
            async (fieldSelector, value, fieldName, element) => {
                await this.handleDateButton(element)
            }
        );


    }


    private nextWeek() {
        let upcomingDate = this.addDays(this.weekStartDate, 7);
        this.generateDates(upcomingDate);
        this.times = [];
    }

    private previousWeek() {
        let upcomingDate = this.addDays(this.weekStartDate, -7);
        this.generateDates(upcomingDate);
        this.times = [];
    }


} 

